var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: [_vm.$style.container, _vm.computedClasses],
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.handleFocus($event);
      }
    }
  }, [_c('masked-input', {
    ref: _vm.internalRef,
    attrs: {
      "value": _vm.value,
      "mask": _vm.mask,
      "pipe": _vm.autocorrectPipe,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.handleInput,
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "submit": _vm.handleSubmit,
      "change": _vm.handleChange
    }
  }), _vm.$scopedSlots.hasOwnProperty('action') ? _c('span', {
    directives: [{
      name: "d-flex",
      rawName: "v-d-flex"
    }]
  }, [_vm._t("action", null, {
    "focus": _vm.internalFocus
  })], 2) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }